<template>
  <template v-if="formItem.type === 'input'">
    <el-input
      v-bind="formItemAttrs"
      v-on="formItem.vOn || {}"
      :placeholder="formItemAttrs.placeholder ?? `请输入${formItem.label}`"
    />
  </template>
  <template v-if="formItem.type === 'inputNumber'">
    <el-input-number  
      class="jd_form_inputNumber"
      v-bind="formItemAttrs"
      style="width: 100%"
      v-on="formItem.vOn || {}"
      :placeholder="formItemAttrs.placeholder ?? `请输入${formItem.label}`" />
  </template>
  <template v-else-if="formItem.type === 'select'">
    <el-select
      style="width: 100%"
      v-bind="formItemAttrs"
      :placeholder="formItemAttrs.placeholder ?? `请选择${formItem.label}`"
      v-on="formItem.vOn || {}"
      clearable
    >
      <el-option
        :key="item.value"
        :label="item.label"
        :value="item.value"
        :disabled="item.disabled"
        v-for="item in formItem.options"
      ></el-option>
    </el-select>
  </template>
  <template
    v-else-if="formItem.type === 'radioButton' || formItem.type === 'radio'"
  >
    <el-radio-group
      style="width: 100%"
      v-bind="formItemAttrs"
      v-on="formItem.vOn || {}"
    >
      <template v-if="formItem.type === 'radioButton'">
        <el-radio-button
          :key="item.label"
          :label="item.value"
          v-for="item in formItem.options"
          >{{ item.label }}</el-radio-button
        >
      </template>
      <template v-else>
        <el-radio
          :key="item.label"
          :label="item.value"
          v-for="item in formItem.options"
          >{{ item.label }}</el-radio
        >
      </template>
    </el-radio-group>
  </template>
  <template v-else-if="formItem.type === 'checkbox'">
    <el-checkbox-group  v-bind="formItemAttrs"
      v-on="formItem.vOn || {}">
    <el-checkbox 
        :key="item.label"
        :label="item.value"
        v-for="item in formItem.options">{{ item.label }}</el-checkbox>
  </el-checkbox-group>
  </template>
  <template v-else-if="formItem.type === 'datePicker'">
    <el-date-picker
      v-bind="formItemAttrs"
      v-on="formItem.vOn || {}"
      :placeholder="formItemAttrs.placeholder ?? `请选择${formItem.label}`"
      :type="formItem?.attrs?.type || 'date'"
  /></template>
  <template v-else-if="formItem.type === 'timePicker'">
    <el-time-picker
      v-bind="formItemAttrs"
      v-on="formItem.vOn || {}"
      :placeholder="formItemAttrs.placeholder ?? `请选择${formItem.label}`"
  /></template>
</template>
<script setup>
import { computed, ref, reactive, onBeforeMount, useAttrs } from "vue";
const props = defineProps({
  formItem: {
    type: Object,
    default: () => {},
  },
});

const attrs = useAttrs();
const formItemAttrs = computed(() => {
  return { ...attrs, ...props.formItem.attrs };
});
</script>
<!-- 注意不要乱改全局样式 -->
<style lang="scss" >
.jd_form_inputNumber.el-input-number .el-input__inner{
  text-align: left !important;
}
</style>